import { render, staticRenderFns } from "./TotalTransactionDataPannelAgent.vue?vue&type=template&id=2bae647e&scoped=true"
import script from "./TotalTransactionDataPannelAgent.vue?vue&type=script&lang=js"
export * from "./TotalTransactionDataPannelAgent.vue?vue&type=script&lang=js"
import style0 from "./TotalTransactionDataPannelAgent.vue?vue&type=style&index=0&id=2bae647e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bae647e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bae647e')) {
      api.createRecord('2bae647e', component.options)
    } else {
      api.reload('2bae647e', component.options)
    }
    module.hot.accept("./TotalTransactionDataPannelAgent.vue?vue&type=template&id=2bae647e&scoped=true", function () {
      api.rerender('2bae647e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/dashboard/components/TotalTransactionDataPannelAgent.vue"
export default component.exports